import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'img[appImageFallback]',
    standalone: false
})
export class ImageFallbackDirective
{

	@Input() appImageFallback: string;

	constructor(private eRef: ElementRef) { }
	errorCount: number = 0;
	@HostListener('error')
	loadFallbackOnError() 
	{
		if (++this.errorCount>1) return;
		const element: HTMLImageElement = <HTMLImageElement>this.eRef.nativeElement;
		element.src = this.appImageFallback || '/assets/image/placeholder-car.png';

	}

}
